import {
  IDynamicItem,
  IDynamicItemMergeOptions,
} from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';
import {
  RemoveOptional,
  StringOrStringArray,
  TypeOrTypeArray,
} from '@epicuro-next/utilities';

export enum RecommendationPanelRequirements {
  basketIsNotEmpty = 'basketIsNotEmpty',
}

export type RecommendationsPanelConfigItemWithConditions = {
  items: (Partial<IDynamicItem> | IDynamicItemMergeOptions)[];
  pathPredicate: StringOrStringArray;
  requirements?: TypeOrTypeArray<RecommendationPanelRequirements>;
};

export function isArrayOfRecommendationsPanelConfigItemWithConditions(
  value: unknown,
): value is RecommendationsPanelConfigItemWithConditions[] {
  const isArray = Array.isArray(value);
  if (!isArray) {
    return false;
  }

  const allAre =
    value.length > 0 &&
    value.every((item) => isRecommendationsPanelConfigItemWithConditions(item));
  if (allAre) {
    return true;
  }

  const anyIs = value.some((item) =>
    isRecommendationsPanelConfigItemWithConditions(item),
  );

  if (anyIs) {
    throw new Error(String.raw`It seems that you have mixed RecommendationsPanelConfigItemWithConditions with other types.
    Please use only RecommendationsPanelConfigItemWithConditions or IDynamicItem[]`);
  }

  return false;
}

export function isRecommendationsPanelConfigItemWithConditions(
  value: unknown,
): value is RecommendationsPanelConfigItemWithConditions {
  if (
    value === null ||
    value === undefined ||
    typeof value !== 'object' ||
    Array.isArray(value)
  ) {
    return false;
  }

  const dummy: Record<
    keyof RemoveOptional<RecommendationsPanelConfigItemWithConditions>,
    undefined
  > = {
    items: undefined,
    pathPredicate: undefined,
  };

  const keys = Object.keys(dummy);

  return keys.every((key) => key in value);
}
